module.exports = __webpack_public_path__ + "static/media/shipDark.3950f6f7.svg";